import { get, post } from "app/apis";
import HelperPriceRoutes from "./HelperPriceRoutes";

const HelperPriceService = {
  getPrice: async () => {
    const data = await get(HelperPriceRoutes.getPrice);
    return data;
  },
  createPrice: async (obj) => {
    const data = await post(HelperPriceRoutes.createPrice, obj);
    return data;
  },
  deletePrice: async (obj) => {
    const data = await post(HelperPriceRoutes.deletePrice, obj);
    return data;
  },
};

export default HelperPriceService;
